<template>
  <div>
    <!-- Only show Noresults when no units are found -->
    <NoResults v-if="(loaded && !isLoading && unitResults === 0) || (loaded && !isLoading && totalResults === 0)"
      :total="totalResults" class="o-retain o-retain--wall" />

    <div class="o-layout o-layout--equalheight o-layout--reverse">
      <div class="o-layout__cell u-fraction--6of12@from-desk" :hidden="isMapHidden">
        <transition name="fade">
          <div class="c-search__wrap-map">
            <div class="c-search__map u-margin-bottom">
              <MapListing v-if="!isMapHidden" :items="getItemsForMap" :locationSearch="isLocationSearch"
                :latitude="latitude" :longitude="longitude" :distance="distance" :zoomChanged="onMapZoomChanged" />
            </div>
          </div>
        </transition>
      </div>
      <div class="o-layout__cell" :class="isMapHidden ? '' : 'u-fraction--6of12@from-desk o-card--listview-maps'
        ">
        <transition name="fade">
          <div v-if="loaded && !isLoading && totalResults > 0">
            <div v-for="unitGroup in unitGroups" :key="unitGroup.key">
              <div v-if="unitGroup.label" class="o-retain o-retain--wall">
                <UnitsHeader v-if="unitGroup.unit || unitGroup.complex || unitGroup.rentalOutside" :complex="unitGroup.complex"
                  :rentalOutside="unitGroup.rentalOutside" :unit="unitGroup.unit" />
                <hr />
                <span v-if="sortType !== 0 && sortType !== 3 && sortType !== 4">
                  <h3 v-if="!(sortType === 1 && unitGroup.items[0].entitytypeid === 2)
                    " class="o-layout u-epsilon u-padding-top-tiny">
                    {{ $label(unitGroup.label) }}
                  </h3>
                </span>
              </div>
              <PropertyListing :items="unitGroup.items" :listheader="$label(unitGroup.label)" />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from '@/constants.js'
import { mapGetters, mapState } from 'vuex'
import PropertyListing from '@/components/Listing/PropertyListing.vue'
import MapListing from '@/components/Listing/MapListing.vue'
import NoResults from '@/components/Listing/NoResults.vue'
import UnitsHeader from '@/components/Listing/UnitsHeader.vue'

export default {
  name: 'results',
  components: { PropertyListing, MapListing, NoResults, UnitsHeader },
  computed: Object.assign(
    mapGetters(['units', 'totalResults', 'unitResults', 'isLoading']),
    mapState(['isLoading', 'loaded']),
    {
      isMapHidden() {
        return this.$store.state.mapVisible == false
      },
      isLocationSearch() {
        return (
          parseInt(this.$store.state.filter.placeType) ===
          Constants.PlaceTypes.Location
        )
      },
      latitude() {
        return this.$store.state.filter.latitude
          ? this.$store.state.filter.latitude.toString()
          : '54'
      },
      longitude() {
        return this.$store.state.filter.longitude
          ? this.$store.state.filter.longitude.toString()
          : '4'
      },
      distance() {
        return this.$store.state.filter.radius
      },
      sortType() {
        return this.units?.sortType || 0
      },
      unitGroups() {
        let units = []

        if (this.units?.sortType === 0 || this.units?.sortType === 3 || this.units?.sortType === 4) {
          if(this.units.newComplexes.length > 0)
          { 
            units.push({ items: 0, label: `Label`, newComplexes: true })
          }
          units.push({ items: this.units.newComplexes })
          units.push({ items: 0, label: `Label`, unit: true })
          units.push({ items: this.units.objects })
          units.push({ items: 0, label: `Label`, complex: true })
          units.push({ items: this.units.complexes })

        }
        else {
          // Always push new complexes first
          for (const [key, items] of Object.entries(this.units.newComplexes)) {
            units.push({ items, key, label: `${key}Label` })
          } 

          // Loop through rental properties
          let unitindex = 0
          for (const [key, items] of Object.entries(this.units.objects)) {
            units.push({
              items,
              key: `unit${key}`,
              label: `${key}Label`,
              unit: unitindex === 0 && units.length !== 0, // check if complex needs a ResultLabel component
            })
            unitindex++
          }

          // Loop through rental properties outside distance range
          if (this.units?.sortType === 2) {
            for (const [key, items] of Object.entries(
              this.units?.objectsOutsideDistance
            )) {
              units.push({
                items,
                key,
                label: `${key}Label`,
                rentalOutside: this.units?.objectsCount !== 0,
              })
            }
          }

          // Loop through complexes and make
          let index = 0
          for (const [key, items] of Object.entries(this.units.complexes)) {
            units.push({
              items,
              key: `complex${key}`,
              label: `${key}Label`,
              complex: index === 0 && units.length !== 0, // check if complex needs a ResultLabel component
            })
            index++
          }
        }
        return units
      },
      getItemsForMap() {
        let items = []

        if (this.units?.objects && this.units?.complexes) {
          const newComplexes = Object.values(this.units.newComplexes).flat()
          const objects = Object.values(this.units.objects).flat()
          const complexes = Object.values(this.units.complexes).flat()

          items.push(...newComplexes, ...objects, ...complexes)
        }

        return items
      },
    }
  ),
  created() {
    this.$store.dispatch('setInitialFilter')
    this.$store.dispatch('getUnits')
    this.$store.dispatch('getSubscriptions')
    this.$store.dispatch('listenForSubscriptionsUpdate')
  },
  methods: {
    onMapZoomChanged(lat, lng, distance) {
      let place = {
        name: this.$store.state.filter.place,
        type: Constants.PlaceTypes.Location,
        lat: lat,
        lng: lng,
      }
      this.$store.dispatch('updatePlace', place)
      this.$store.dispatch('updateRadius', distance)
      this.$store.dispatch('getUnits')
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
